import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { bootstrapAmSuiteAuth } from '@neworg-net/amsuite-core/auth';

import { AppModule } from './app/app.module';
import { environment, amSuitePlatformOptions } from './environments/environment';
import { installChunkLoadRecovery } from './app/shared/chunk-load-recovery';

installChunkLoadRecovery();


if (environment.production) {
  enableProdMode();
}

// Orchestrazione auth pre-AppModule centralizzata nella lib:
// initialize → handleRedirectPromise → setActiveAccount → prewarmTokenCache →
// redirect a /login se serve login interattivo (status 'redirected').
// AppModule viene avviato SOLO se status === 'bootstrap'.
const bootstrapApp = () => platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true })],
  });

bootstrapAmSuiteAuth(amSuitePlatformOptions)
  .then(result => result.status === 'bootstrap'
    ? bootstrapApp().then(() => undefined)
    : undefined) // 'redirected' → la lib ha già reindirizzato; NON bootstrappare (no stato zombie)
  // Degrado: avvia comunque AppModule se l'inizializzazione MSAL fallisce.
  .catch(() => bootstrapApp())
  // Evita una rejection globale se anche il bootstrap Angular non può completarsi.
  .catch(() => undefined);
